import { Button } from 'crux';
import React from 'react';
import get from 'lodash/get';
import at from 'lodash/at';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled, { withTheme } from 'styled-components';
import TextElement from './index';
import { getNextQuestionSet } from '../../../redux/actions';
import ReviewBreadcrumb from '../../QuestionsLib/ReviewBreadcrumb';
import { getCSSVariables } from '../../../cruxComponents/utils';

const ButtonWrapper = styled.div`
  margin-bottom: 30px;
  & > button {
    padding-right: 0;
  }
`;

const GroupQuestionTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const GroupQuestionText = ({ questionObj, uid, makeAPICall, handlePopup, role, theme }) => {
  const {
    question_id: questionId,
    question_text: questionText,
    question_type: questionType,
    question_description: questionDescription,
    isBreadcrumbCard,
    is_edit_icon_visible: isEditable,
  } = questionObj;

  // CSS Variables
  const element = '.groupQuestionText';
  const pElement = '.textElement-p';
  const updateButtonElement = '.button-update';
  const cssVariables = getCSSVariables(theme, 'groupQuestionText');
  const _font = at(cssVariables, [`pageOverride.font${element}`, `global.font${element}`]);
  const font = _font?.[0] || _font?.[1];
  const pFont = at(cssVariables, [`pageOverride.font${pElement}`, `global.font${pElement}`]);
  const updateButtonFont = at(cssVariables, [
    `pageOverride.font${updateButtonElement}`,
    `global.font${updateButtonElement}`,
  ]);
  if (!questionText && !questionDescription) {
    return null;
  }
  if (isBreadcrumbCard) {
    return <ReviewBreadcrumb question={ questionObj } />;
  }

  const updateButtonTheme = get(theme, 'config.theme.global.updateButton.themeConfiguration', {});
  updateButtonTheme.font = updateButtonFont[0] || updateButtonFont[1];
  const displayUpdateButton = questionType === 'group' && isEditable;
  const handleUpdate = () => {
    const params = {
      uid,
      q_id: questionId,
    };
    makeAPICall(params);
  };

  if (!questionText && !questionDescription) {
    return null;
  }
  return (
    <>
      <GroupQuestionTextWrapper name='group-question-text-wrapper'>
        {questionText && (
          <TextElement
            id={ `group-header-${questionId}` }
            text={ questionText }
            styleType='questions_group'
            font={ font }
            questionObj={ questionObj }
            role={ role }
          />
        )}
        {displayUpdateButton && (
          <ButtonWrapper name='button-wrapper'>
            <Button
              label='Update'
              type='text'
              handleButtonClick={ handleUpdate }
              ariaLabel={ `Update ${questionText}` }
              themeConfiguration={ updateButtonTheme }
            />
          </ButtonWrapper>
        )}
      </GroupQuestionTextWrapper>
      {questionDescription && (
        <TextElement
          text={ questionDescription }
          styleType='normal'
          handlePopup={ handlePopup }
          pFont={ pFont[0] || pFont[1] }
          questionObj={ questionObj }
        />
      )}
    </>
  );
};

GroupQuestionText.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  questionObj: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    uid: state.uid,
    role: get(state, 'questions.role'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    makeAPICall: (params) => {
      dispatch(getNextQuestionSet('/questions', params));
    },
  };
};

export default withTheme(connect(mapStateToProps, mapDispatchToProps)(GroupQuestionText));
